'use client';

import * as React from 'react';
import { useMemo, useState } from 'react';
import { noop } from 'lodash';
import { createContext, useContextSelector } from 'use-context-selector';
import type { ProjectStatusInput } from '@frameio/graphql-client/generated';

export type WorkspacesProjectFilter = 'ALL' | ProjectStatusInput;
type WorkspacesFilterValue = {
  filter: WorkspacesProjectFilter;
  setFilter: (filter: WorkspacesProjectFilter) => void;
};

const WorkspacesProjectFilterContext = createContext<WorkspacesFilterValue>({
  filter: 'ACTIVE',
  setFilter: noop,
});

export const WorkspacesProjectFilterContextProvider: React.FC<
  React.PropsWithChildren
> = ({ children }) => {
  const [filter, setFilter] = useState<WorkspacesProjectFilter>('ACTIVE');
  const value = useMemo<WorkspacesFilterValue>(() => {
    return {
      filter,
      setFilter,
    };
  }, [filter]);

  return (
    <WorkspacesProjectFilterContext.Provider value={value}>
      {children}
    </WorkspacesProjectFilterContext.Provider>
  );
};

export const useWorkspacesProjectFilter = () => {
  return useContextSelector(
    WorkspacesProjectFilterContext,
    (value) => value.filter
  );
};

export const useSetWorkspacesProjectFilter = () => {
  return useContextSelector(
    WorkspacesProjectFilterContext,
    (value) => value.setFilter
  );
};
